(() => {
  'use strict';

  const ROOT_CLASS = 'ci3d-intelligent-filters';
  const GUIDE_CLASS = 'ci3d-filter-guide';
  const OMNI_PRODUCTS = [
    {
      handle: 'xtool-o1-omni-uv-printer-with-single-uv-rotary-bundle',
      label: 'Omni UV + Rotary bundle'
    },
    {
      handle: 'xtool-o1-omni-uv-dtg-printer-versatile-bundle',
      label: 'Omni UV + DTG bundle'
    }
  ];

  const FILTER_HELP = {
    'printer type': 'Choose FDM for practical parts or resin for fine detail.',
    'best for': 'Match the machine to your experience and workload.',
    'user level': 'Match the machine to your experience and workload.',
    enclosure: 'Enclosed machines offer better control for demanding materials.',
    'build volume': 'The maximum part size the printer can produce.',
    'build size': 'The maximum part size the printer can produce.',
    'filament material': 'Choose the base material for strength, flexibility and finish.',
    'material features': 'Narrow by high-speed, reinforced, silk and specialist options.',
    'filament type': 'Narrow by high-speed, reinforced, silk and specialist options.',
    colour: 'Find the colour or finish required for your project.',
    color: 'Find the colour or finish required for your project.',
    'laser technology': 'Diode, CO2, fibre and UV lasers suit different materials.',
        'material compatibility': 'Choose only materials the laser source can mark or cut safely and effectively.',
    'camera & automation': 'Camera positioning and automation features improve repeatability and batch workflows.',
    'pre-order eta': 'Shows the supplier arrival window for incoming products.',
    'laser output power': 'Higher output generally increases cutting capability and speed.',
    'laser power (w)': 'Higher output generally increases cutting capability and speed.',
    'work area': 'Match the usable bed size to your typical jobs.',
    'accessory type': 'Choose the upgrade or replacement category you need.',
    material: 'Choose the blank or sheet material you plan to engrave or cut.',
    finish: 'Narrow by the surface appearance required for the finished job.',
    'scanner technology': 'Match the capture method to the objects and accuracy you need.',
    'scanner connectivity': 'Choose the connection method that fits your workflow.',
    accuracy: 'Lower values indicate finer measurement capability.',
    'scan size': 'Choose a scanner suited to small parts, people or large objects.',
    'part type': 'Choose the component family you need to replace.',
    'compatible model': 'Use your exact printer model to avoid incompatible parts.',
    brand: 'Filter by manufacturer.',
    availability: 'Show products currently available to order.',
    price: 'Set a comfortable budget range in rand.'
  };

  const LABELS = {
    'laser power (w)': 'Laser Output Power',
    'laser power': 'Laser Output Power',
    'build size': 'Build Volume',
    'user level': 'Best For',
    'filament type': 'Material Features',
    color: 'Colour',
    'scanner accuracy': 'Accuracy',
    'spare part type': 'Part Type',
    'compatible printer': 'Compatible Model'
  };

  const CONFIGS = [
    {
      key: 'filament',
      match: /filament|pla\b|petg\b|\babs\b|\basa\b|\btpu\b|nylon|carbon[ -]?fi(?:ber|bre)/i,
      eyebrow: 'Smart material finder',
      title: 'Find the right filament faster',
      text: 'Start with material, then narrow by features, colour, brand, availability and price. Results update automatically.',
      priority: ['Filament Material', 'Material Features', 'Filament Type', 'Colour', 'Color', 'Brand', 'Availability', 'Price'],
      quickValues: ['PLA', 'PETG', 'ABS', 'TPU', 'Black', 'White', 'In stock'],
      prices: [{ label: 'Under R500', max: 500 }, { label: 'R500–R1,000', min: 500, max: 1000 }]
    },
    {
      key: 'laser-materials',
      match: /laser material|laser blank|engraving material/i,
      eyebrow: 'Smart material finder',
      title: 'Find the right laser material',
      text: 'Choose the material and finish first, then narrow by size, availability and budget.',
      priority: ['Material', 'Material Type', 'Finish', 'Lumber/Wood Type', 'Size', 'Brand', 'Availability', 'Price'],
      quickValues: ['Acrylic', 'Wood', 'In stock'],
      prices: [{ label: 'Under R500', max: 500 }, { label: 'R500–R1,500', min: 500, max: 1500 }]
    },
    {
      key: 'laser-accessories',
      match: /laser accessor|laser upgrade|honeycomb|air assist|rotary roller|smoke purifier|laser module|lens|optic/i,
      eyebrow: 'Accessory compatibility finder',
      title: 'Find the correct laser accessory',
      text: 'Start with accessory type and compatible machine, then narrow by power, enclosure, brand and stock status.',
      priority: ['Accessory Type', 'Compatible Model', 'Compatible Machine', 'Laser Output Power', 'Laser Power (w)', 'Enclosure', 'Brand', 'Availability', 'Price'],
      quickValues: ['Air Assist', 'Rotary Roller', 'Honeycomb Bed', 'Enclosure', 'In stock'],
      prices: [{ label: 'Under R1,000', max: 1000 }, { label: 'R1,000–R5,000', min: 1000, max: 5000 }]
    },
    {
      key: 'omni',
      match: /xtool omni|o1 omni/i,
      eyebrow: 'xTool Omni · Special order',
      title: 'Choose your xTool O1 Omni printer',
      text: 'Both printer bundles are special-order pre-orders. Choose dedicated UV printing with a rotary attachment, or the versatile UV and DTG bundle.',
      priority: ['Product Type', 'Brand', 'Availability', 'Price'],
      quickValues: [],
      prices: [],
      featuredLinks: OMNI_PRODUCTS
    },
    {
      key: 'laser-machine',
      match: /laser|engraver|engraving/i,
      eyebrow: 'Smart laser finder',
      title: 'Start with the material, then narrow the machine',
      text: 'Choose the laser source and intended materials first, then refine by power, enclosure, work area, automation and budget.',
      priority: ['Best For', 'Material Compatibility', 'Laser Technology', 'Laser Type', 'Work Area', 'Enclosure', 'Camera & Automation', 'Pre-order ETA', 'Laser Output Power', 'Laser Power (w)', 'Brand', 'Availability', 'Price'],
      hide: ['Accessory Type', 'Filament Material', 'Material Features', 'Filament Type', 'Resin Type', 'Scanner Technology', 'Scanner Connectivity', 'Scanner Accuracy', 'Spare Part Type'],
      quickValues: ['Diode', 'Fibre', 'UV', 'Enclosed', 'In stock'],
      prices: [
        { label: 'Under R10,000', max: 10000 },
        { label: 'R10,000–R30,000', min: 10000, max: 30000 },
        { label: 'R30,000–R70,000', min: 30000, max: 70000 },
        { label: 'R70,000+', min: 70000 }
      ]
    },
    {
      key: 'cnc-accessories',
      match: /cnc accessor|cnc upgrade|cnc spindle|cnc motor|rotary axis|cutting bit|tooling/i,
      eyebrow: 'CNC compatibility finder',
      title: 'Find the correct CNC accessory',
      text: 'Choose the accessory or tooling type first, then narrow by compatible machine, brand, availability and price.',
      priority: ['Accessory Type', 'Tool Type', 'Compatible Model', 'Compatible Machine', 'Brand', 'Availability', 'Price'],
      quickValues: ['In stock'],
      prices: [{ label: 'Under R1,000', max: 1000 }, { label: 'R1,000–R5,000', min: 1000, max: 5000 }]
    },
    {
      key: 'cnc-machine',
      match: /cnc machine|cnc router/i,
      eyebrow: 'Smart CNC finder',
      title: 'Choose the right CNC machine',
      text: 'Narrow by machine type, working area, spindle capability, brand, availability and budget.',
      priority: ['Machine Type', 'Work Area', 'Spindle Power', 'Brand', 'Availability', 'Price'],
      quickValues: ['In stock'],
      prices: [{ label: 'Under R10,000', max: 10000 }, { label: 'R10,000–R30,000', min: 10000, max: 30000 }]
    },
    {
      key: 'scanner-accessories',
      match: /scanner accessor/i,
      eyebrow: 'Scanner accessory finder',
      title: 'Find a compatible scanner accessory',
      text: 'Choose the accessory type and compatible scanner model before narrowing by brand, stock status and price.',
      priority: ['Accessory Type', 'Compatible Model', 'Scanner Technology', 'Brand', 'Availability', 'Price'],
      quickValues: ['Creality', 'In stock'],
      prices: [{ label: 'Under R1,000', max: 1000 }, { label: 'R1,000–R5,000', min: 1000, max: 5000 }]
    },
    {
      key: 'scanner',
      match: /3d scanner|scanners|scanning/i,
      eyebrow: 'Smart scanner finder',
      title: 'Match the scanner to the object',
      text: 'Narrow by accuracy, scan size, portability, tracking method, brand and budget.',
      priority: ['Scanner Type', 'Scanner Technology', 'Accuracy', 'Scanner Accuracy', 'Scan Size', 'Portable', 'Tracking Method', 'Scanner Connectivity', 'Brand', 'Availability', 'Price'],
      quickValues: ['Portable', 'Creality', 'In stock'],
      prices: [{ label: 'Under R10,000', max: 10000 }, { label: 'R10,000–R30,000', min: 10000, max: 30000 }]
    },
    {
      key: 'spares',
      match: /spare|replacement|hotend|nozzle|extruder|build plate|screen|electronics|belt|motor|motion|fan|cooling|sensor/i,
      eyebrow: 'Compatibility finder',
      title: 'Find the correct spare part',
      text: 'Start with the printer brand and exact compatible model, then choose the part type. If unsure, contact us before ordering.',
      priority: ['Compatible Model', 'Compatible Printer', 'Part Type', 'Brand', 'Availability', 'Price'],
      quickValues: ['Creality', 'Elegoo', 'FlashForge', 'Raise3D', 'In stock'],
      prices: [{ label: 'Under R500', max: 500 }, { label: 'R500–R1,500', min: 500, max: 1500 }]
    },
    {
      key: 'resin',
      match: /resin/i,
      eyebrow: 'Smart resin finder',
      title: 'Choose resin by application and performance',
      text: 'Narrow by resin type, application, colour, brand, availability and price.',
      priority: ['Resin Type', 'Application', 'Colour', 'Color', 'Brand', 'Availability', 'Price'],
      quickValues: ['Standard', 'Engineering', 'Dental', 'Jewellery', 'In stock'],
      prices: [{ label: 'Under R500', max: 500 }, { label: 'R500–R1,000', min: 500, max: 1000 }]
    },
    {
      key: 'printer',
      match: /3d printer|printers|fdm|enclosed|industrial 3d|large format/i,
      eyebrow: 'Smart printer finder',
      title: 'Find your ideal 3D printer',
      text: 'Choose the printing process first, then narrow by experience level, enclosure, build volume, brand and budget.',
      priority: ['Printer Type', 'Best For', 'User Level', 'Enclosure', 'Build Volume', 'Build Size', 'Brand', 'Availability', 'Price'],
      hide: ['Filament Type'],
      quickValues: ['FDM', 'Resin', 'Enclosed', 'Beginner', 'Professional', 'In stock'],
      prices: [{ label: 'Under R10,000', max: 10000 }, { label: 'R10,000–R25,000', min: 10000, max: 25000 }]
    },
    {
      key: 'generic',
      match: /.*/,
      eyebrow: 'Smart product finder',
      title: 'Narrow the range with confidence',
      text: 'Use the most relevant product attributes, stock status and price to find the best match.',
      priority: ['Product Type', 'Brand', 'Availability', 'Price'],
      hide: ['Accessory Type', 'Laser Output Power', 'Laser Power (w)', 'Filament Material', 'Material Features', 'Filament Type', 'Colour', 'Color', 'Printer Type', 'Best For', 'User Level', 'Enclosure', 'Build Volume', 'Build Size', 'Resin Type', 'Laser Technology', 'Scanner Technology', 'Scanner Connectivity', 'Accuracy', 'Scanner Accuracy', 'Part Type', 'Spare Part Type'],
      quickValues: ['xTool', 'In stock'],
      prices: []
    }
  ];

  function normalise(value) {
    return String(value || '')
      .replace(/\u00a0/g, ' ')
      .replace(/[–—]/g, '-')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function canonicalValue(filterKey, value) {
    let key = normalise(value);

    if (filterKey.includes('build')) {
      key = key.replace(/\s*-\s*/g, '-').replace(/(\d)mm/g, '$1 mm');
    }

    const aliases = {
      hobyist: 'Hobbyist',
      'carbon fiber': 'Carbon Fibre',
      'carbon-fiber': 'Carbon Fibre',
      'carbon fibre': 'Carbon Fibre',
      'glass fiber': 'Glass-Fibre Reinforced',
      'glass fibre': 'Glass-Fibre Reinforced',
      'high speed': 'High-Speed',
      'high-speed petg filament': 'High-Speed',
      'pla+ high speed': 'High-Speed',
      'rapid petg': 'High-Speed',
      'rapid pla+': 'High-Speed',
      'pla-cf (carbon fiber reinforced pla)': 'Carbon-Fibre Reinforced',
      'pla matte filament': 'Matte',
      'support filament': 'Support Material',
      'double pack': 'Multi-Pack',
      'tpu 95a flexible filament': 'Flexible'
    };

    if (aliases[key]) return aliases[key];
    if (/^\d+(\.\d+)?$/.test(key) && filterKey.includes('laser')) return `${key}W`;
    if (filterKey.includes('build')) return key.replace(/(^|\s)\w/g, (letter) => letter.toUpperCase()).replace(/-/g, '–');
    return String(value || '').trim();
  }

  function pageContext() {
    const root = document.querySelector('.collection');
    const handle = normalise(root?.dataset.collectionHandle || '');
    const heading = root?.dataset.collectionTitle || document.querySelector('h1')?.textContent || '';
    const pathname = window.location.pathname.replace(/[-_/]+/g, ' ');
    const source = `${heading} ${pathname}`;
    const findConfig = (key) => CONFIGS.find((config) => config.key === key);

    // Exact catalogue families win over broad words such as "laser", "printer" or "resin".
    if (/xtool-omni-range/.test(handle)) return findConfig('omni');
    if (/laser-material/.test(handle)) return findConfig('laser-materials');
    if (/laser.*(?:accessor|upgrade)|laser-modules?/.test(handle)) return findConfig('laser-accessories');
    if (/cnc-(?:accessor|upgrade|spindle|rotary|cutting-bit)|cnc-spindles|cnc-rotary/.test(handle)) return findConfig('cnc-accessories');
    if (/cnc-machine/.test(handle)) return findConfig('cnc-machine');
    if (/3d-scanner-accessor/.test(handle)) return findConfig('scanner-accessories');
    if (/spare|replacement|hotend|nozzle|extruder|build plate|screen|electronics|belt|motor|motion|fan|cooling|sensor/i.test(source)) return findConfig('spares');
    if (/3d scanner|scanners|scanning/i.test(source)) return findConfig('scanner');
    if (/filament|pla\b|petg\b|\babs\b|\basa\b|\btpu\b|nylon|carbon[ -]?fi(?:ber|bre)/i.test(source)) return findConfig('filament');
    if (/laser|engraver|engraving/i.test(source)) return findConfig('laser-machine');
    if (/3d printer|printers|fdm|enclosed|industrial 3d|large format/i.test(source)) return findConfig('printer');
    if (/resin/i.test(source)) return findConfig('resin');

    // A brand or search collection can have a neutral title. Only infer a family
    // when its available filters point to one clear product category.
    const availableHeadings = normalise(
      [...document.querySelectorAll('#FacetFiltersContainer details[data-filter] summary .h6')]
        .map((element) => element.childNodes[0]?.nodeValue || element.textContent)
        .join(' | ')
    );
    const inferred = [
      ['spares', /compatible model|compatible printer|part type/],
      ['scanner', /scanner type|scanner technology|scan size|tracking method/],
      ['filament', /filament material/],
      ['laser-machine', /laser power|laser technology|laser type|work area/],
      ['printer', /printer type|user level|build size|build volume/],
      ['resin', /resin type/]
    ].filter(([, pattern]) => pattern.test(availableHeadings));

    return inferred.length === 1 ? findConfig(inferred[0][0]) : findConfig('generic');
  }

  function filterKey(details) {
    if (details.dataset.ci3dFilterKey) return details.dataset.ci3dFilterKey;
    const heading = details.querySelector('summary .h6');
    const key = normalise(heading?.childNodes?.[0]?.nodeValue || heading?.textContent || '');
    details.dataset.ci3dFilterKey = key;
    return key;
  }

  function displayLabel(key) {
    return LABELS[key] || key.replace(/(^|\s)\w/g, (letter) => letter.toUpperCase());
  }

  function enhanceHeading(details) {
    const key = filterKey(details);
    const heading = details.querySelector('summary .h6');
    if (!heading) return;

    const label = displayLabel(key);
    if (heading.childNodes[0]?.nodeType === Node.TEXT_NODE) {
      heading.childNodes[0].nodeValue = `${label} `;
    }

    let badge = heading.querySelector('.ci3d-filter-count-badge');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'ci3d-filter-count-badge';
      badge.setAttribute('aria-hidden', 'true');
      heading.appendChild(badge);
    }

    if (!heading.querySelector('.ci3d-filter-group-help')) {
      const help = FILTER_HELP[normalise(label)] || FILTER_HELP[key];
      if (help) {
        const helper = document.createElement('small');
        helper.className = 'ci3d-filter-group-help';
        helper.textContent = help;
        heading.appendChild(helper);
      }
    }
  }

  function mergeAliases(details) {
    const key = filterKey(details);
    const items = [...details.querySelectorAll('li')];
    const groups = new Map();

    items.forEach((item) => {
      const label = item.querySelector('label');
      const input = item.querySelector('input[type="checkbox"]');
      if (!label || !input || input.disabled) return;
      const labelText = label.querySelector('.reversed-link__text')?.textContent || label.textContent;
      const canonical = canonicalValue(key, labelText);
      const groupKey = normalise(canonical);
      if (!groups.has(groupKey)) groups.set(groupKey, []);
      groups.get(groupKey).push({ item, label, input, canonical });
    });

    groups.forEach((group) => {
      const primary = group[0];
      const primaryText = primary.label.querySelector('.reversed-link__text');
      if (primaryText) primaryText.textContent = primary.canonical;

      if (group.length < 2) return;

      const aliases = group.slice(1);
      const isActive = group.some((entry) => entry.input.checked);
      primary.input.checked = isActive;
      const count = group.reduce((total, entry) => {
        const number = parseInt(entry.item.querySelector('.count')?.textContent?.replace(/\D/g, '') || '0', 10);
        return total + number;
      }, 0);
      const countNode = primary.item.querySelector('.count');
      if (countNode && count) countNode.textContent = String(count);

      aliases.forEach((entry) => {
        entry.item.classList.add('ci3d-merged-option');
        entry.input.checked = isActive;
      });

      if (!primary.input.dataset.ci3dAliasBound) {
        primary.input.dataset.ci3dAliasBound = 'true';
        primary.input.addEventListener('change', () => {
          aliases.forEach((entry) => {
            entry.input.checked = primary.input.checked;
          });
        });
      }
    });
  }

  function addValueSearch(details) {
    const content = details.querySelector('.accordion-details__content');
    const visibleItems = [...details.querySelectorAll('li:not(.ci3d-merged-option)')];
    if (!content || visibleItems.length <= 8 || content.querySelector('.ci3d-filter-search')) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'ci3d-filter-search';

    const input = document.createElement('input');
    input.className = 'ci3d-filter-search__input';
    input.type = 'search';
    input.autocomplete = 'off';
    input.placeholder = `Search ${displayLabel(filterKey(details)).toLowerCase()}`;
    input.setAttribute('aria-label', input.placeholder);

    input.addEventListener('input', () => {
      const query = normalise(input.value);
      visibleItems.forEach((item) => {
        const label = normalise(item.querySelector('label')?.textContent || '');
        const matches = !query || label.includes(query);
        if (query) {
          item.classList.toggle('hidden', !matches);
        } else {
          item.classList.toggle('hidden', item.classList.contains('show-more-item'));
        }
      });
    });

    wrapper.appendChild(input);
    content.prepend(wrapper);
  }

  function updateSelectedCount(details) {
    const selected = [...details.querySelectorAll('li:not(.ci3d-merged-option) input[type="checkbox"]:checked')].length;
    const badge = details.querySelector('.ci3d-filter-count-badge');
    if (badge) badge.textContent = selected ? String(selected) : '';
    if (selected) details.open = true;
  }

  function orderAndEnhanceForm(form, config) {
    const details = [...form.querySelectorAll(':scope > details[data-filter]')];
    if (!details.length) return;

    const priority = config.priority.map(normalise);
    const hidden = (config.hide || []).map(normalise);

    details.forEach((detail) => {
      enhanceHeading(detail);
      mergeAliases(detail);
      addValueSearch(detail);
      updateSelectedCount(detail);
      detail.classList.toggle('ci3d-context-hidden', hidden.includes(filterKey(detail)));
    });

    details
      .sort((a, b) => {
        const aIndex = priority.indexOf(normalise(displayLabel(filterKey(a))));
        const bIndex = priority.indexOf(normalise(displayLabel(filterKey(b))));
        const aRank = aIndex === -1 ? 999 : aIndex;
        const bRank = bIndex === -1 ? 999 : bIndex;
        return aRank - bRank;
      })
      .forEach((detail) => form.appendChild(detail));

    const isDesktop = form.closest('#FacetFiltersContainer');
    if (isDesktop) {
      [...form.querySelectorAll(':scope > details:not(.ci3d-context-hidden)')].slice(0, 4).forEach((detail) => {
        detail.open = true;
      });
    }

    if (!form.dataset.ci3dChangeBound) {
      form.dataset.ci3dChangeBound = 'true';
      form.addEventListener('change', () => {
        form.querySelectorAll(':scope > details[data-filter]').forEach(updateSelectedCount);
        window.requestAnimationFrame(updateQuickPickState);
      });
    }
  }

  function allFacetForms() {
    return [...document.querySelectorAll('#FacetFiltersContainer form[is="facet-form"], #DrawerFacetFiltersContainer form[is="facet-form"]')];
  }

  function findCheckbox(value) {
    const wanted = normalise(value).replace(/w$/, '');
    const form = allFacetForms()[0];
    if (!form) return null;

    return [...form.querySelectorAll('li:not(.ci3d-merged-option) input[type="checkbox"]')].find((input) => {
      const item = input.closest('li');
      const label = item?.querySelector('label');
      const text = normalise(label?.querySelector('.reversed-link__text')?.textContent || label?.textContent || '').replace(/w$/, '');
      return text === wanted;
    }) || null;
  }

  function applyPrice(min, max) {
    const form = allFacetForms()[0];
    if (!form) return;

    const minInput = form.querySelector('input[name="filter.v.price.gte"]');
    const maxInput = form.querySelector('input[name="filter.v.price.lte"]');
    if (!minInput || !maxInput) return;

    minInput.value = min || '';
    maxInput.value = max || '';
    maxInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function updateQuickPickState() {
    document.querySelectorAll('.ci3d-quick-filter[data-value]').forEach((button) => {
      const input = findCheckbox(button.dataset.value);
      button.setAttribute('aria-pressed', input?.checked ? 'true' : 'false');
      button.disabled = !input;
      button.hidden = !input;
    });

    document.querySelectorAll('.ci3d-quick-filter[data-price]').forEach((button) => {
      const form = allFacetForms()[0];
      const currentMin = Number(form?.querySelector('input[name="filter.v.price.gte"]')?.value || 0);
      const currentMax = Number(form?.querySelector('input[name="filter.v.price.lte"]')?.value || 0);
      const wantedMin = Number(button.dataset.min || 0);
      const wantedMax = Number(button.dataset.max || 0);
      button.setAttribute('aria-pressed', currentMin === wantedMin && currentMax === wantedMax ? 'true' : 'false');
    });
  }

  function createQuickPick(label, attributes, onClick) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'ci3d-quick-filter';
    button.textContent = label;
    button.setAttribute('aria-pressed', 'false');
    Object.entries(attributes).forEach(([name, value]) => {
      if (value !== undefined && value !== null) button.dataset[name] = String(value);
    });
    button.addEventListener('click', onClick);
    return button;
  }

  function buildGuide(root, config) {
    let guide = root.querySelector(`.${GUIDE_CLASS}`);
    if (guide) return guide;

    guide = document.createElement('section');
    guide.className = GUIDE_CLASS;
    guide.setAttribute('aria-label', 'Product finder');
    guide.innerHTML = `
      <div class="ci3d-filter-guide__copy">
        <span class="ci3d-filter-guide__eyebrow"></span>
        <h2 class="ci3d-filter-guide__title"></h2>
        <p class="ci3d-filter-guide__text"></p>
      </div>
      <div class="ci3d-filter-guide__picks" aria-label="Popular filters"></div>
    `;

    guide.querySelector('.ci3d-filter-guide__eyebrow').textContent = config.eyebrow;
    guide.querySelector('.ci3d-filter-guide__title').textContent = config.title;
    guide.querySelector('.ci3d-filter-guide__text').textContent = config.text;

    const picks = guide.querySelector('.ci3d-filter-guide__picks');

    (config.featuredLinks || []).forEach((item) => {
      const link = document.createElement('a');
      link.className = 'ci3d-quick-filter ci3d-quick-filter--product';
      link.href = `/products/${item.handle}`;
      link.textContent = item.label;
      picks.appendChild(link);
    });

    config.quickValues.forEach((value) => {
      if (!findCheckbox(value)) return;
      picks.appendChild(createQuickPick(value === '20' || value === '40' || value === '60' ? `${value}W` : value, { value }, () => {
        const input = findCheckbox(value);
        if (input) input.click();
      }));
    });

    config.prices.forEach((range) => {
      const form = allFacetForms()[0];
      if (!form?.querySelector('input[name="filter.v.price.lte"]')) return;
      picks.appendChild(createQuickPick(range.label, { price: 'true', min: range.min || 0, max: range.max || 0 }, () => {
        applyPrice(range.min, range.max);
      }));
    });

    const toolbar = root.querySelector('.collection__toolbar')?.closest('.sticky-element');
    if (toolbar) toolbar.before(guide);
    else root.prepend(guide);

    updateQuickPickState();
    return guide;
  }

  function enhanceOmniProducts() {
    const featuredColumns = [];

    OMNI_PRODUCTS.forEach((item) => {
      const link = document.querySelector(`.product-card a[href^="/products/${item.handle}"]`);
      const card = link?.closest('.product-card');
      if (!card) return;

      card.classList.add('ci3d-special-order-card');
      const media = card.querySelector('.product-card__image-wrapper');
      if (media && !media.querySelector('.ci3d-special-order-badge')) {
        const badge = document.createElement('span');
        badge.className = 'ci3d-special-order-badge';
        badge.textContent = 'Special order · Pre-order';
        media.appendChild(badge);
      }

      const column = card.closest('.product-column');
      if (column) featuredColumns.push(column);
    });

    if (!/\/collections\/xtool-omni-range(?:\/|$)/.test(window.location.pathname)) return;
    const list = document.querySelector('#ProductsList');
    [...featuredColumns].reverse().forEach((column) => list?.prepend(column));
  }

  function enhanceLegacyCollectionSeo() {
    document.querySelectorAll('.ci3d-collection-seo').forEach((section) => {
      const inner = section.querySelector('.ci3d-collection-seo__inner');
      const content = section.querySelector('.ci3d-collection-seo__content');
      if (!inner || !content || section.classList.contains('ci3d-collection-seo--enhanced')) return;

      const details = document.createElement('details');
      details.className = 'ci3d-collection-seo__details';

      const summary = document.createElement('summary');
      summary.className = 'ci3d-collection-seo__summary';
      summary.innerHTML = `
        <span>
          <strong>Open the complete buying guide</strong>
          <small>Compatibility, applications, replacement guidance and expert advice.</small>
        </span>
        <span class="ci3d-collection-seo__summary-icon" aria-hidden="true">+</span>
      `;

      details.append(summary, content);
      inner.appendChild(details);
      section.classList.add('ci3d-collection-seo--enhanced');
    });
  }

  function initialise() {
    const root = document.querySelector('.collection');
    if (!root) return;

    root.classList.add(ROOT_CLASS);
    const config = pageContext();
    allFacetForms().forEach((form) => orderAndEnhanceForm(form, config));
    buildGuide(root, config);
    enhanceOmniProducts();
    enhanceLegacyCollectionSeo();
    updateQuickPickState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }

  document.addEventListener('collection:rerendered', () => {
    window.requestAnimationFrame(initialise);
  });
})();

